import { Palette } from '@common/theming/Palette';
import React from 'react';
import { AssetBlockProps } from '../../pages/Asset';
import { TextBlock } from '../TextBlock';

export const TopEmployers: React.FC<AssetBlockProps> = ({ asset }) => {
  return (
    <div>
      <TextBlock color={Palette.BLACK} weight={'bold'} size={24}>
        {asset.topEmployers?.heading}
      </TextBlock>
      <div style={{ padding: 24 }}>
        <img style={{ width: '100%' }} src={asset.topEmployers?.employersImage.file.url} />
      </div>
    </div>
  );
};
